if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.mode = this.dataset.mode;

      if (this.mode === "slider") {
        this.initSlider();
      } else {
        this.initScroll();
      }
    }

    // ===== SCROLL MODE (existing) =====
    initScroll() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let i = 0; i < 10; i++) {
          const clone = this.promotion.cloneNode(true);
          clone.setAttribute("aria-hidden", true);
          this.appendChild(clone);
        }

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting
              ? this.classList.remove("m-scrolling-promotion--paused")
              : this.classList.add("m-scrolling-promotion--paused");
          });
        });

        observer.observe(this);
      }
    }

    // ===== SLIDER MODE (NEW) =====
    initSlider() {
      this.promotion.classList.remove("m-promotion--animated");
      this.items = Array.from(this.querySelectorAll(".m-promotion__item"));
      this.index = 0;

      this.prevBtn = this.querySelector(".m-slider-prev");
      this.nextBtn = this.querySelector(".m-slider-next");

      // Wait for images to load
      window.addEventListener("load", () => this.updateSlider());
      window.addEventListener("resize", () => this.updateSlider());

      // Button events
      this.nextBtn.addEventListener("click", () => {
        this.nextSlide();
        this.resetAutoplay();
      });

      this.prevBtn.addEventListener("click", () => {
        this.prevSlide();
        this.resetAutoplay();
      });

      // Start autoplay
      this.startAutoplay();
    }

    // Move to next slide
    nextSlide() {
      this.index = (this.index + 1) % this.items.length;
      this.updateSlider();
    }

    // Move to previous slide
    prevSlide() {
      this.index = (this.index - 1 + this.items.length) % this.items.length;
      this.updateSlider();
    }

    // ===== Autoplay =====
    startAutoplay() {
      const interval = promotion_slide_speed * 1000; // convert seconds to milliseconds
      this.autoplayTimer = setInterval(() => this.nextSlide(), interval);
    }

    // Reset autoplay on manual interaction
    resetAutoplay() {
      clearInterval(this.autoplayTimer);
      this.startAutoplay();
    }

    updateSlider() {
      // width of the slider viewport (visible area)
      const viewportWidth = this.offsetWidth;
      this.promotion.style.transition = "transform 0.4s ease";
      this.promotion.style.transform = `translateX(-${this.index * viewportWidth}px)`;
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}